import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close the mobile menu when the window is resized beyond mobile breakpoint
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024 && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [menuOpen]);

      // Navigation items
      const navItems = [
        { name: 'Home', path: '/' },
        { name: 'Guides', path: '/guide' },
        { name: 'Upgrades', path: '/upgrades' },
        { name: 'Shop', path: '/merchshop' },
        { name: 'Events', path: '/events' },
        //{ name: 'Forum', path: '/forum' },
        //{ name: 'Mystveil', path: '/profile' },
        { name: 'RULES', path: '/rules', highlight: true }
      ];

  return (
    <header className="mystical-nav sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Mystical Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="mystical-logo">
              <img 
                src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_logo.png" 
                alt="Mystveil Township Logo" 
                className="h-12 mystical-logo"
              />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:block">
            <ul className="flex space-x-4">
              {navItems.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path} 
                    className={`
                      mystical-nav-item text-sm px-3 py-2 rounded-md transition-colors duration-200
                      ${item.highlight 
                        ? 'text-yellow-300 font-bold hover:text-yellow-200' 
                        : 'text-white hover:text-yellow-300'
                      }
                      ${location.pathname === item.path ? 'text-yellow-300 bg-white bg-opacity-20' : ''}
                    `}
                  >
                    {item.highlight ? `| ${item.name} |` : item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button 
              className="p-2 rounded-md text-white hover:text-yellow-300 hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-yellow-300 transition-all duration-200"
              onClick={toggleMenu}
              aria-label="Toggle navigation menu"
            >
              {menuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        <div className={`lg:hidden transition-all duration-300 ${menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className={`
                  mystical-nav-item block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200
                  ${item.highlight 
                    ? 'text-yellow-300 font-bold hover:text-yellow-200' 
                    : 'text-white hover:text-yellow-300'
                  }
                  ${location.pathname === item.path ? 'bg-white bg-opacity-20 text-yellow-300' : ''}
                `}
                onClick={() => setMenuOpen(false)}
              >
                {item.highlight ? `| ${item.name} |` : item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;